
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"image","stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{staticClass:"i-stroke",attrs:{"d":"M3.833 14.5h9.334c.736 0 1.333-.597 1.333-1.333V3.833c0-.736-.597-1.333-1.333-1.333H3.833c-.736 0-1.333.597-1.333 1.333v9.334c0 .736.597 1.333 1.333 1.333Zm0 0H5.75l5.75-6 3 2.5"}}),_c('path',{staticClass:"i-stroke_2",attrs:{"d":"M6.75 8.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"}})])])
          )
        }
      }
    